<template>
  <div class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" id="register-form">

    <div class="max-w-lg w-full space-y-8">
      <div>
        <!--        <img class="mx-auto h-12 w-auto" src="https://www.sineora.com/app-assets/images/logo/sineora_logo-full.png" alt="Workflow"/>-->
        <div>
          <svg class="mx-auto h-16 w-auto" viewBox="0 0 85 23" xmlns="http://www.w3.org/2000/svg">
            <g transform="matrix(.06126 0 0 .06126 7.069 2.501)">
              <path
                  d="m164 186c21.4 0 38.7-17.3 38.7-38.7s-17.3-38.7-38.7-38.7c-20.1-2.14-59.6-15-64.2-62.7 0-21.4-17.3-38.7-38.7-38.7s-38.7 17.3-38.7 38.7 17.3 38.7 38.7 38.7c20.4 1.77 64.4 15.5 64.2 62.7 0.19 47.2-43.9 59.7-64.5 61.9-21.4 0-38.7 17.3-38.7 38.7s17.3 38.7 38.7 38.7 38.7-17.3 38.7-38.7c7.46-44.2 44.5-61 64.5-61.9"
                  fill="#053b5b" stroke="#000" stroke-width=".265px"/>
              <circle cx="-35.9" cy="147" r="38.7" fill="#f28916" fill-rule="evenodd"
                      style="paint-order:stroke fill markers"/>
            </g>
            <g transform="matrix(.1378 0 0 .1378 -80.97 -45.28)" stroke-width=".118">
              <path
                  d="m770 449c-8.25-1.77-17.5-6.22-20.4-14.6 3.66-2.14 7.34-4.24 11-6.35 4.45 7.59 15.2 11.9 22.8 6.23 7.47-8.45-5.17-14.3-11.9-16.6-8.34-3.32-17.2-9.37-17.7-19.2-1.94-10.6 6.73-21.3 17.5-21.7 8.88-1.24 19.2 1.64 23.5 10.2-1.33 3.54-6.62 5.04-9.74 7.58-3.05-4.55-12.6-9.15-16.7-2.29-3.72 10.4 10.3 12.3 16.8 16.1 8.07 3.59 15.5 11.1 14.7 20.6 0.751 10-7.81 18.4-17.4 19.8-3.9 1.16-8.36 0.636-12.4 0.354zm129 0.0547c-14.7-14.5-30.3-28-44.4-43.1-0.428 6.67 0.258 14.1 0.146 21 0.0706 7.1 0.137 14.2 0.206 21.3h-13.1c0.121-23.7-0.299-47.3 0.295-71 5.06 1.84 10.6 9.18 15.6 13.2 10 9.44 20.1 18.9 29.5 28.9 0.587-6.82-0.299-14.4-0.123-21.5-0.0809-6.84-0.158-13.7-0.237-20.5h13.1c-0.0466 23.7 0.386 47.4-0.0934 71.1 0.228 0.519-0.524 1.33-0.958 0.548zm-87.1-36.2v-35.5h14.1v70.9h-14.1v-35.5zm104-3e-3v-35.5c15.6 0.0605 31.2 0.121 46.7 0.181v11.6c-10.7 0.186-21.5-0.198-32.2 0.576-0.961 7.56-0.305 15.3-0.384 23 9.55 0.256 19.1 0.307 28.7 0.451v11.6c-9.52 0.118-19 0.235-28.6 0.353v10.6c11.3 0.118 22.6 0.235 33.9 0.353 0.0643 4.06 0.129 8.11 0.193 12.2h-48.3v-35.5z"
                  fill="#053b5b"/>
              <path
                  d="m1007 449c0-0.169-0.833-0.417-1.85-0.55-2.65-0.347-7.78-2.13-10.8-3.75-12.3-6.63-19.5-19.7-18.6-34.2 0.79-13.9 8.96-25.7 21.4-31.1 10.1-4.33 21.8-4.14 31.7 0.523 4.38 2.07 7.08 4.03 10.5 7.57 4.22 4.42 6.7 8.75 8.6 15 0.906 2.99 0.963 3.58 0.968 10.1 0 7.56-0.324 9.45-2.59 14.9-2.3 5.52-7.4 11.8-12.3 15.1-4.32 2.9-12.2 6.01-15.2 6.01-0.404 0-0.735 0.159-0.735 0.353 0 0.22-2.06 0.353-5.47 0.353-3.01 0-5.47-0.138-5.47-0.307zm11.1-13c7.03-1.7 13.4-7.94 15.5-15.3 0.972-3.31 1.36-7.82 0.956-11.1-1.2-9.77-6.59-16.9-15-19.8-2.45-0.852-3.35-0.977-7.04-0.986-3.4-8e-3 -4.72 0.142-6.7 0.765-7.12 2.24-12.8 8.33-14.9 16-0.46 1.68-0.628 3.61-0.632 7.23-4e-3 4.2 0.119 5.33 0.821 7.58 2.07 6.62 5.99 11.5 11.4 14.1 5.02 2.41 10.2 2.94 15.6 1.61zm44.5 11.8c-0.092-0.243-0.127-16.2-0.077-35.4l0.091-34.9 11.6-0.11c12.6-0.119 16 0.136 21 1.58 9.02 2.6 15.2 8.58 17.5 16.9 0.868 3.15 1.07 11 0.374 14.3-1.26 6.01-5.03 11.3-10.2 14.3-1.33 0.765-2.48 1.58-2.57 1.82-0.09 0.235 3.02 5.2 6.92 11 3.89 5.84 7.08 10.7 7.08 10.8 0 0.103-3.61 0.145-8.03 0.0925l-8.03-0.0938-2-3c-1.1-1.65-3.72-5.62-5.82-8.82l-3.82-5.82-4.54-0.099c-3.04-0.0664-4.7 0.0349-5.03 0.308-0.394 0.327-0.49 2.1-0.49 9.01v8.6h-6.89c-5.19 0-6.93-0.109-7.06-0.441zm27.3-30.4c6.39-1.81 9.36-6.09 9.36-13.5 0-8.71-4.01-13.2-12.9-14.3-4.01-0.503-8.87-0.473-9.4 0.0565-0.315 0.315-0.423 3.96-0.423 14.2 0 7.59 0.119 13.9 0.265 14.1 0.441 0.457 11-0.0517 13.1-0.628zm32.2 30.4c0.015-0.247 6.96-16.3 15.4-35.7 9.66-22.1 15.6-35.3 15.9-35.3 0.299 0 6.52 13.3 16.3 34.9 8.71 19.2 15.9 35.3 16 35.7l0.206 0.794h-7.05c-5.23 0-7.14-0.114-7.38-0.441-0.183-0.243-0.938-1.91-1.68-3.7-0.739-1.79-1.54-3.42-1.78-3.62-0.286-0.237-5.45-0.33-15-0.269l-14.6 0.0922-3.26 7.76-6.58 0.096c-5.16 0.0751-6.58 0-6.56-0.353zm40.5-20.1c0.066-0.344-1.18-3.76-2.78-7.58-1.59-3.83-3.6-9.1-4.45-11.7-0.852-2.62-1.68-4.89-1.83-5.04-0.495-0.495-0.954 0.49-2.59 5.57-0.878 2.72-2.87 8.01-4.44 11.8-1.56 3.75-2.76 7.05-2.65 7.33 0.161 0.42 1.7 0.486 9.41 0.408 8.5-0.0867 9.23-0.143 9.34-0.72z"
                  fill="#f28916"/>
            </g>
          </svg>
        </div>


        <div class="mt-8">
          <!-- Corporation Step One -->
          <template v-if="isCorporationStepOne">
            <div class="flex flex-col justify-center items-center w-full h-full md:w-auto md:h-auto">
              <h1 class="mb-2 font-merriweatherSans font-semibold text-2xl text-secondary-500 text-center">
                {{ title }}
              </h1>
              <h2 class="w-full mb-4  text-base text-black text-center">
                {{ stepOneSubtitle }}
              </h2>
              <p v-if="displayDuplicateErrorMessage"
                 class="w-full mt-4 mb-4  text-base text-ternary text-center font-bold">
                An account already exists with this email address. <br>
                <button class="underline font-bold" @click="$router.push({name: 'forgot-password'})">
                  Forgot your password?
                </button>
              </p>
              <p v-if="displayApiErrorMessage"
                 class="w-full mt-4 mb-4  text-base text-ternary text-center font-bold">
                Please check your information, some errors exist.
              </p>
              <div class="w-full">

                <!-- TODO: Update form with real data -->
                <form class="flex flex-col items-center" @submit="checkCorporationStepOneForm">
                  <div class="flex flex-col md:flex-row w-full">
                    <div class="flex flex-col w-full md:w-1/2 mr-0 md:mr-6">
                      <div class="w-full ">
                        <input id="corporationFirstName"
                               v-model.trim="corporationFirstName"
                               type="text"
                               maxlength="32"
                               name="corporationFirstName"
                               placeholder="First name"
                               class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                               required="required"/>
                      </div>
                      <p v-if="corporationFirstNameError" class=" text-base text-red-500">
                        {{ corporationFirstNameError }}
                      </p>
                    </div>
                    <div class="flex flex-col w-full md:w-1/2">
                      <div class="w-full">
                        <input id="corporationLastName"
                               v-model.trim="corporationLastName"
                               type="text"
                               maxlength="32"
                               name="corporationLastName"
                               placeholder="Last name"
                               class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                               required="required"/>
                      </div>
                      <p v-if="corporationLastNameError" class=" text-base text-red-500">
                        {{ corporationLastNameError }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col w-full">
                    <input id="corporationEmail"
                           v-model.trim="corporationEmail"
                           type="email"
                           name="corporationEmail"
                           placeholder="Email"
                           class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                           required="required"/>
                    <p v-if="corporationEmailError" class=" text-base text-red-500">
                      {{ corporationEmailError }}
                    </p>
                    <input id="corporationPassword"
                           v-model="corporationPassword"
                           type="password"
                           name="corporationPassword"
                           placeholder="Password"
                           class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                           required="required"/>
                    <p v-if="corporationPasswordError" class=" text-base text-red-500">
                      {{ corporationPasswordError }}
                    </p>
                    <input id="corporationConfirmPassword"
                           v-model="corporationConfirmPassword"
                           type="password"
                           name="corporationConfirmPassword"
                           placeholder="Confirm password"
                           class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                           required="required"/>
                    <p v-if="corporationConfirmPasswordError" class=" text-base text-red-500">
                      {{ corporationConfirmPasswordError }}
                    </p>
                  </div>
                  <p v-if="false" class="mt-4 mb-4  text-base text-black text-center">Or</p>

                  <!-- TODO: Check links -->
                  <div v-if="false" class="flex flex-col items-center md:flex-row justify-between mb-6">
                    <a href="/connect/facebook"
                       class="inline-flex mr-0 mb-4 md:mr-4 md:mb-0 bg-facebook-blue rounded-md p-4  text-base text-white">
                      <img :src="facebookLogo" alt="facebook" class="mr-2.5">
                      Facebook
                    </a>
                    <a href="/connect/google"
                       class="inline-flex mr-0 mb-4 md:mr-4 md:mb-0 bg-google-orange rounded-md p-4  text-base text-white">
                      <img :src="googleLogo" alt="google" class="mr-2.5">
                      Google
                    </a>
                    <a href="/connect/linkedin"
                       class="inline-flex mr-0 mb-4 md:mr-4 md:mb-0 bg-linkedin-blue rounded-md p-4  text-base text-white">
                      <img :src="linkedinLogo" alt="linkedin" class="mr-2.5">
                      LinkedIn
                    </a>
                    <a href="/connect/twitter"
                       class="inline-flex bg-twitter-blue rounded-md p-4  text-base text-white">
                      <img :src="twitterLogo" alt="twitter" class="mr-2.5">
                      Twitter
                    </a>
                  </div>

                  <!-- TODO: Check link -->
                  <p class="mt-6 mb-10  text-base text-black text-center">
                    {{ policy }}
                    <a href="https://www.sineora.com/en/legal/privacy-statement" target="_blank"
                       class="font-bold text-secondary-500">privacy policy</a>
                  </p>
                  <button type="submit"
                          class="mb-6 font-semibold py-2 px-4 bg-secondary-500 rounded-md text-white hover:bg-secondary-light transition duration-150 ease-in-out">
                    Continue
                  </button>
                </form>
              </div>
              <p class=" text-base text-black text-center">
                {{ loginOption }}
                <button @click="$router.push('login')"
                        class="font-bold text-secondary-500"> login here
                </button>
              </p>
            </div>
          </template>

          <!-- Corporation Step Two -->
          <template v-if="isCorporationStepTwo">
            <div class="flex flex-col justify-center items-center w-full h-full md:w-auto md:h-auto">
              <h1 class="mb-2 font-semibold text-2xl text-secondary-500 text-center">
                {{ title }}
              </h1>
              <h2 class="w-full md:w-9/12 mb-6 text-base text-black text-center">
                {{ stepTwoSubtitle }}
              </h2>
              <div class="flex flex-col w-full mb-6">
                <p class="mb-1  font-semibold text-base text-secondary-500">
                  {{ generalInformations }}
                </p>

                <!-- TODO: Update form with real data -->
                <form class="flex flex-col items-center" @submit="checkCorporationStepTwoForm">
                  <div class="flex flex-col  w-full mb-6">
                    <input id="corporateCompany"
                           v-model.trim="corporateCompany"
                           type="text"
                           name="corporateCompany"
                           placeholder="Company name"
                           class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                           required="required"/>
                    <p v-if="corporateCompanyError" class=" text-base text-red-500">
                      {{ corporateCompanyError }}
                    </p>
                    <input v-model.trim="corporateWebsite"
                           type="text" placeholder="Website"
                           class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
                           required="required"/>
                    <p v-if="corporateWebsiteError" class=" text-base text-red-500">
                      {{ corporateWebsiteError }}
                    </p>
                    <v-select class=""
                              v-model.trim="corporateCompanyCountry"
                              :options="countriesOptions"
                              :placeholder="'Country'"
                              :required="'required'"
                              :reduce="n => n.code !== null ? n.code : n">
                    </v-select>
                    <p v-if="corporateCompanyCountryError" class=" text-base text-red-500">
                      {{ corporateCompanyCountryError }}
                    </p>
                  </div>


                  <div class="flex flex-col w-full mb-6">
                    <p class="mb-1  font-semibold text-base text-secondary-500">
                      {{ foundingInformations }}
                    </p>
                    <div class="flex flex-col">
                      <input id="corporateCompanyTitle" v-model.trim="corporateCompanyTitle" type="text"
                             name="corporateCompanyTitle" placeholder="Title in the company"
                             class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"/>
                      <p v-if="corporateCompanyTitleError" class=" text-base text-red-500">
                        {{ corporateCompanyTitleError }}
                      </p>
                      <input id="corporateCompanyDivision" v-model.trim="corporateCompanyDivision" type="text"
                             name="corporateCompanyDivision" placeholder="Division in the company"
                             class="w-full h-12 my-2 px-4 py-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"/>
                      <p v-if="corporateCompanyDivisionError" class=" text-base text-red-500">
                        {{ corporateCompanyDivisionError }}
                      </p>
                    </div>
                  </div>


                  <div class="flex flex-col w-full mb-6">
                    <p class="mb-1  font-semibold text-base text-secondary-500">
                      {{ selectIndustries }}
                    </p>
                    <v-select class=""
                              id="interests-select"
                              v-model="corporateCompanyInterest"
                              @search="onFetchTags"
                              :options="interestOptions"
                              :reduce="n => n.code !== null ? n.code : n"
                              :placeholder="'Select industries and/or technologies'"
                              multiple>
                    </v-select>
                  </div>


                  <p class="w-full md:w-9/12 mb-6  text-base text-black text-center">
                    If you want to receive personalized information on your inbox, fill in the form below.
                  </p>
                  <button type="submit"
                          class="font-semibold py-2 px-4 bg-secondary-500 rounded-md text-white hover:bg-secondary-light transition duration-150 ease-in-out">
                    <template v-if="accountRegisterProcessing">
                      <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101"
                           fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"/>
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"/>
                      </svg>
                      Processing
                    </template>
                    <template v-else>
                      Continue
                    </template>
                  </button>

                </form>
              </div>
            </div>
          </template>

          <!-- Corporation Validated -->
          <template v-if="isValidated">
            <div class="flex flex-col items-center w-full h-full md:w-auto md:h-auto">
              <h1 class="mb-4 font-semibold text-2xl text-secondary text-center">
                {{ validationTitle }}
              </h1>
              <h2 class="w-full md:w-9/12 mb-16 font-semibold text-2xl text-secondary text-center">
                {{ validationSubtitle }}
              </h2>
              <img :src="validationChecked" alt="checked" class="mb-14">
              <p class="w-full md:w-3/5 font-sourceSansPro text-base text-black text-center">
                {{ validationText }}
              </p>
              <button
                  @click="$router.push({ name: 'login', query: { email: this.corporationEmail, redirected: 1, 'register-success': true } })"
                  type="button"
                  class="font-semibold mt-8 py-2 px-4 bg-secondary-500 rounded-md text-white hover:bg-secondary-light transition duration-150 ease-in-out">
                Go to sign in page
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import localizesCountries from '@/assets/data/countries.json'
import _debounce from "lodash.debounce";
import _get from "lodash/get";

export default {
  name: "CorporateRegister",
  components: {
    vSelect,
  },
  data() {
    return {
      isCorporationStepOne: true,
      isCorporationStepTwo: false,
      isValidated: false,
      title: 'Sign Up: Create your company account',
      choiceSubtitle: 'Select the better description for your innovation company',
      corporationDescription: 'Looking to find inspiration about technology trends to be used in my company and to find the right startup to hire.',
      startupDescription: 'My company is offering a new and exciting technology and we want to have better exposure.',
      loginOption: 'If you already have an account,',
      stepOneSubtitle: 'Use your corporate e-mail address',
      stepTwoSubtitle: 'To get the most out of Sineora and find the right companies for you, complete the following information.',
      generalInformations: 'General company information',
      foundingInformations: 'Other information',
      selectIndustries: 'Add industries and/or Technologies of interest',
      policy: 'By creating an account, you declare that you agree our',
      identificationLabel: 'Your startup has not been identified by SINEORA.',
      identificationLabelPrecision: '(you cant create an account if you startup is already identified by SINEORA)',
      validationTitle: 'Congratulation !',
      validationSubtitle: 'Your registration has been taken into account !',
      validationChecked: require('@/assets/images/icons/checked.svg'),
      validationText: 'You can now have access to all the information and support you need for your innovation.',
      facebookLogo: require('@/assets/images/logo/facebook.svg'),
      googleLogo: require('@/assets/images/logo/google.svg'),
      linkedinLogo: require('@/assets/images/logo/linkedin.svg'),
      twitterLogo: require('@/assets/images/logo/twitter.svg'),
      businessDomain: 'Business Domain',
      businessOptions: [
        'Food and Agriculture',
        'Health and Medical Care',
        'Education',
        'Construction',
        'Real Estate',
        'Media and Advertisement',
        'Consumer Goods and Consumer Packaging Goods',
        'Travel and Tourism',
        'Manufacturing',
        'Transportation and Logic',
        'Retail',
        'Research and Consulting',
        'Material and Energy',
        'Security',
        'Banking and Insurance',
        'Other, please specify'
      ],
      interestOptions: [],
      countriesOptions: [],
      corporationFirstName: null,
      corporationFirstNameError: null,
      corporationLastName: null,
      corporationLastNameError: null,
      corporationEmail: _get(this.$route.query, 'email', null),
      corporationEmailError: null,
      corporationPassword: null,
      corporationPasswordError: null,
      corporationConfirmPassword: null,
      corporationConfirmPasswordError: null,
      corporateCompany: null,
      corporateCompanyError: null,
      corporateWebsite: null,
      corporateWebsiteError: null,
      corporateCompanyCountry: null,
      corporateCompanyCountryError: null,
      corporateCompanyTitle: null,
      corporateCompanyTitleError: null,
      corporateCompanyDivision: null,
      corporateCompanyDivisionError: null,
      corporateCompanyInterest: null,

      displayDuplicateErrorMessage: false,
      displayApiErrorMessage: false,
      accountRegisterProcessing: false,

      _emailRegex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      _passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{12,}$/,
    }
  },
  created() {
    if (!this.countriesOptions.length) {
      const locale = 'en';
      for (const alpha3 in localizesCountries) {
        this.countriesOptions.push({label: localizesCountries[alpha3][locale], code: alpha3});
      }
    }
  },
  mounted() {
    if (!this.interestOptions.length) {
      this.fetchTags(() => undefined, '', this)
    }
  },
  methods: {
    selectCorporationStepTwo() {
      this.isCorporationStepOne = false;
      this.isCorporationStepTwo = true;
    },
    selectValidation() {
      this.isCorporationStepTwo = false;
      this.isValidated = true;
    },
    checkCorporationStepOneForm(e) {
      let atLeastOneError = false;

      this.displayDuplicateErrorMessage = false;
      this.displayApiErrorMessage = false;
      this.corporationFirstNameError = null;
      this.corporationLastNameError = null;
      this.corporationEmailError = null;
      this.corporationPasswordError = null;
      this.corporationConfirmPasswordError = null;

      if (!this.corporationFirstName || this.corporationFirstName.length > 35) {
        this.corporationFirstNameError = 'A valid first name is required';
        atLeastOneError = true;
      }
      if (!this.corporationLastName || this.corporationLastName.length > 35) {
        this.corporationLastNameError = 'A valid last name is required';
        atLeastOneError = true;
      }
      if (!this.corporationEmail || !this._emailRegex.test(this.corporationEmail)) {
        this.corporationEmailError = 'A valid email is required';
        atLeastOneError = true;
      }
      if (!this.corporationPassword || !this._passwordRegex.test(this.corporationPassword)) {
        this.corporationPasswordError = 'A valid password is required. Your password must be 12 characters long with at least one upper, lower and numeric character.'
        atLeastOneError = true;
      }
      if (!this.corporationConfirmPassword) {
        this.corporationConfirmPasswordError = 'Confirmed password is required';
        atLeastOneError = true;
      }
      if (this.corporationPassword && this.corporationConfirmPassword && this.corporationPassword !== this.corporationConfirmPassword) {
        this.corporationConfirmPasswordError = 'Your passwords do not match';
        atLeastOneError = true;
      }

      if (!atLeastOneError) {
        this.selectCorporationStepTwo();
      }

      e.preventDefault();
    },
    checkCorporationStepTwoForm(e) {
      let atLeastOneError = false;

      this.corporateCompanyError = null;
      this.corporateWebsiteError = null;
      this.corporateCompanyCountryError = null;
      this.corporateCompanyTitleError = null;
      this.corporateCompanyDivisionError = null;

      if (!this.corporateCompany) {
        this.corporateCompanyError = 'A valid company name is required';
        atLeastOneError = true;
      }
      if (!this.corporateWebsite || this.corporateWebsite.length > 255) {
        this.corporateWebsiteError = 'A valid website address is required for the company';
        atLeastOneError = true;
      }
      if (!this.corporateCompanyCountry) {
        this.corporateCompanyCountryError = 'A valid country is required for the company';
        atLeastOneError = true;
      }

      // if (!this.corporateCompanyTitle) {
      //   this.corporateCompanyTitleError = 'Title in the company is required';
      // atLeastOneError = true;
      // }
      // if (!this.corporateCompanyDivision) {
      //   this.corporateCompanyDivisionError = 'Division in the company is required';
      // atLeastOneError = true;
      // }

      if (!atLeastOneError) {
        this.registerCorporate();
      }

      e.preventDefault();
    },

    registerCorporate() {
      this.accountRegisterProcessing = true;

      let website = this.corporateWebsite;
      if (!website.startsWith('http')) {
        website = 'https://' + website
      }

      const data = {
        "firstName": this.corporationFirstName,
        "lastName": this.corporationLastName,
        "email": this.corporationEmail,
        "password": this.corporationPassword,
        "confirmedPassword": this.corporationConfirmPassword,
        "companyName": this.corporateCompany,
        "companyWebsite": website,
        "companyCountry": this.corporateCompanyCountry,
        "companyTitle": this.corporateCompanyTitle,
        "companyDivision": this.corporateCompanyDivision,
        "companyInterests": this.corporateCompanyInterest,
      };

      this.$store
          .dispatch("registerCorporate", data)
          .then(function (data) {
            this.selectValidation()
            this.accountRegisterProcessing = false;
          }.bind(this))
          .catch(function (error) {
            if (error.response.status === 409) {
              this.displayDuplicateErrorMessage = true;
            }
            if (error.response.status === 400) {
              [
                {property: 'firstName', localProperty: 'corporationFirstName'},
                {property: 'lastName', localProperty: 'corporationLastName'},
                {property: 'email', localProperty: 'corporationEmail'},
                {property: 'password', localProperty: 'corporationPassword'},
                {property: 'confirmedPassword', localProperty: 'corporationConfirmPassword'},
                {property: 'companyName', localProperty: 'corporateCompany'},
                {property: 'companyWebsite', localProperty: 'corporateWebsite'},
                {property: 'companyCountry', localProperty: 'corporateCompanyCountry'},
                {property: 'companyTitle', localProperty: 'corporateCompanyTitle'},
                {property: 'companyDivision', localProperty: 'corporateCompanyDivision'},
                {property: 'companyInterests', localProperty: 'corporateCompanyInterest'},
              ].forEach(function (item) {
                const regex = new RegExp(`${item.property}: ([^\\n]*)`, 'i');
                let propertyFound;
                if (null !== (propertyFound = regex.exec(error.response.data['hydra:description']))) {
                  this[`${item.localProperty}Error`] = propertyFound[1];
                }
              }.bind(this));
              this.displayApiErrorMessage = true;
            }

            this.isCorporationStepOne = true;
            this.isCorporationStepTwo = false;
            this.isValidated = false;
            this.accountRegisterProcessing = false;
          }.bind(this));
    },


    onFetchTags(search, loading) {
      if (search.length) {
        loading(true);
        this.fetchTags(loading, search, this);
      }
    },
    fetchTags: _debounce(async function (loading, search, vm) {
      const [technologies, activities] = await Promise.all([
        this.$axios
            .get('/entity-technologies?name=' + escape(search), {})
            .then(function (response) {
              return response.data['hydra:member'].map(function (item) {
                return {code: 'T-' + item.id, label: item.name}
              });
            }.bind(this)),

        this.$axios
            .get('/entity-activities?name=' + escape(search), {})
            .then(function (response) {
              return response.data['hydra:member'].map(function (item) {
                return {code: 'A-' + item.id, label: item.name}
              });
            }.bind(this))
      ]);

      vm.interestOptions = activities.concat(technologies).sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });

      loading(false);

    }, 350),

  }
}
</script>

<style>
#register-form input::placeholder {
  color: #5D5D5D !important;
}

#register-form .vs__dropdown-toggle {
  height: 48px !important;
  margin: 8px 0;
  border-radius: 6px !important;
  border-color: #5D5D5D !important;
  background-color: white !important;
}

#register-form .vs__search::placeholder {
  font-size: 1rem !important;
}

#register-form .vs__selected-options {
  padding: 0 12px !important;
}

#register-form .vs__selected {
  font-size: 1rem;
}

#register-form #countries-select {
  margin: 0 0 16px 0;
}

#register-form #interests-select .vs__dropdown-toggle {
  min-height: 48px !important;
  height: auto !important;
}

#register-form #interests-select .vs__dropdown-menu {
  text-transform: capitalize;
}

#register-form #interests-select .vs__selected-options {
  align-items: center !important;
}

#register-form #interests-select .vs__selected {
  color: black !important;
}
</style>